import { Grid, Typography, Box, CircularProgress, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WifiOff as WifiOffIcon } from "@mui/icons-material";
import { useCallback, useEffect, useState } from "react";

export default function OfflinePage() {
  const { t } = useTranslation();
  const [isConnecting, setIsConnecting] = useState(true);


  useEffect(() => {
    if (typeof document === "undefined") return;

    let timer;

    const start = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setIsConnecting(false), 15000);
    };

    const stop = () => {
      clearTimeout(timer);
      setIsConnecting(true);
    };

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        start();
      } else {
        stop();
      }
    };

    handleVisibility();
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibility);
      setIsConnecting(true);
    };
  }, []);

  const onReload = useCallback(() => {
    try {
      window?.location?.reload();
    } catch (err) {
      console.log(err);
    }
  }, []);


  return (
    <Box sx={{ height: "100%", width: "100%", position: "absolute" }}>
      <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
        <Grid item container spacing={1} direction="column" alignItems="center">

          <Grid item>
            {
              isConnecting ? (
                <CircularProgress sx={{ width: "64px", height: "64px" }} color="info" size="large" variant="indeterminate" />
              ) : (
                <WifiOffIcon sx={{ width: "64px", height: "64px" }} color="warning" />
              )
            }
          </Grid>

          <Grid item >
            <Stack alignItems="center">
              <Typography variant="h6" textAlign="center">{isConnecting ? t("connecting:title") : t("offline:title")}</Typography>
              <Typography variant="body1" textAlign="center" sx={{ width: "360px", maxWidth: "calc(100vw - 32px)", marginBottom: "24px" }} color="textSecondary">{isConnecting ? t("connecting:description") : t("offline:description")}</Typography>
              <Button onClick={onReload} sx={{ marginBottom: "78px" }} variant="contained" color="neutral">{t("connecting:restart")}</Button>
            </Stack>
          </Grid>

        </Grid>
      </Grid>
    </Box>
  );
}